/* eslint-disable max-len */
// GENERATED BY process-svg DO NOT EDIT
import React from 'react'
import { Icon, Props } from './Icon'

export const IconZoomIn = (props: Props) => (
  <Icon {...props}>
    <path className="path1" d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6-9C11.99 5 14 7.01 14 9.5S11.99 14 9.5 14 5 11.99 5 9.5 7.01 5 9.5 5zm.5 2H9v2H7v1h2v2h1v-2h2V9h-2V7z"  fillRule="nonzero" />
  </Icon>
)

// for use with mapbox addables.
export const IconZoomInString =
  `<svg viewbox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path className="path1" d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6-9C11.99 5 14 7.01 14 9.5S11.99 14 9.5 14 5 11.99 5 9.5 7.01 5 9.5 5zm.5 2H9v2H7v1h2v2h1v-2h2V9h-2V7z"  fillRule="nonzero" />
  </svg>`

IconZoomIn.displayName = 'IconZoomIn'
